import React, { useState } from 'react'
import style from "css/myreservation.module.css";
import SegmentBar from './segmentBar';

import ReservationDetail from '../reservationDetail';

function MyReservationInfo({ hotdeskingScheduleList, meetingScheduleList, isLoading }) {
    const [activeMenu, setActiveMenu] = useState("Today");

    return (
        <div className={style.myreservation_wrapper}>
            <SegmentBar activeMenu={activeMenu} menuChange={(menu) => setActiveMenu(menu)} />
            <div className={style.myreservation_content}>
                <ReservationDetail
                    hotdeskingScheduleList={
                        activeMenu === "Today" ? hotdeskingScheduleList.today
                            : activeMenu === "진행 예정" ? hotdeskingScheduleList.future : []
                        // : activeMenu === "지난 내역" ? hotdeskingScheduleList.past : []
                    }
                    meetingScheduleList={
                        activeMenu === "Today" ? meetingScheduleList.today
                            : activeMenu === "진행 예정" ? meetingScheduleList.future : []
                        // : activeMenu === "지난 내역" ? meetingScheduleList.past : []
                    }
                    type={activeMenu}
                    isLoading={isLoading}
                />
            </div>
        </div>
    )
}

export default MyReservationInfo
